export const TIMELINE_MAX_WIDTH_PER_SECOND = 500;
export const TIMELINE_ITEM_ACCEPTABLE_EDITING_WIDTH = 150;
export const TIMELINE_MIN_WIDTH_PER_SECOND = 1;
export const BOTTOM_BAR_MAX_HEIGHT = 261;
export const POSTER_EDITOR_WEB_BOTTOM_BAR_CONTAINER_ID = 'editor-web-bottom-seekbar';
export const POSTER_EDITOR_MOBILE_BOTTOM_BAR_CONTAINER_ID = 'editor-mobile-web-bottom-seekbar';
